<template>
  <div v-loading="loading" class="main-frame">
    <el-container>
      <el-header class="banner-head">
        <div class="head-info">
          <el-row>
            <el-col style="text-align: left" :span="12">
              <el-page-header :title="$t('back')" @back="goBack" :content="$t('role.detail')"></el-page-header>
            </el-col>
            <el-col style="text-align: right" :span="12">
              <el-button type="primary" icon="el-icon-check" @click="saveModel">
                {{
                $t("save")
                }}
              </el-button>
            </el-col>
          </el-row>
        </div>
      </el-header>
      <el-main>
        <el-form
          class="edit-form"
          :model="role_model"
          :rules="rules"
          ref="modelForm"
          label-width="100px"
        >
          <CopyPaste
            :button_status="this.role_id !== undefined && this.role_id.length > 0"
            @copyInfo="copyInfo(role_model)"
            @pasteInfo="pasteInfo"
            ref="copyPaste"
          ></CopyPaste>
          <el-form-item :label="$t('role.name') + ':'" prop="name">
            <el-input v-model="role_model.name" clearable></el-input>
          </el-form-item>
          <el-form-item :label="$t('status') + ':'">
            <el-select
              v-model="role_model.status"
              :placeholder="$t('statusMsg')"
              :loading-text="$t('loading')"
            >
              <el-option
                v-for="item in $t('statusSelectList')"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('weight') + ':'">
            <el-input-number v-model="role_model.number" :min="0" :label="$t('weight')"></el-input-number>
          </el-form-item>
          <el-form-item v-for="(category_item, i) in auth_tree_list" :key="category_item.id">
            <el-checkbox
              @change="(val) => handleCheckAllChange(val, category_item)"
              :indeterminate="itemIndeterminate(category_item)"
              v-model="category_item.checkAll"
            >{{ category_item.name }}</el-checkbox>
            <el-checkbox
              @change="(val) => handleCheckReadChange(val, category_item)"
              :indeterminate="itemIndeterminate(category_item)"
              v-model="category_item.checkAll"
            >{{ $t("role.onlyRead") }}</el-checkbox>
            <el-checkbox-group
              v-model="choose_api_id_list"
              @change="(value) => handleCheckedCitiesChange(value, i)"
            >
              <el-checkbox
                v-for="item in category_item.api_list"
                :label="item.id"
                :key="item.id"
              >{{ item.name }}</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
        </el-form>
      </el-main>
    </el-container>
  </div>
</template>

<script>
import CopyPaste from "../../../components/copyPaste.vue";
export default {
  name: "RoleDetailView",
  components: {
    CopyPaste
  },
  data() {
    return {
      loading: false,
      role_id: "",
      role_model: {
        id: "",
        name: "",
        number: 0,
        status: 2,
        role_api_list: []
      },
      choose_api_id_list: [],
      auth_tree_list: [],
      rules: {
        name: [
          {
            required: true,
            message: this.$t("admin.rulesNameTip"),
            trigger: "blur"
          },
          { min: 3, message: this.$t("admin.rulesValid"), trigger: "blur" }
        ]
      },
      checkAll: false,
      isIndeterminate: true
    };
  },
  created() {
    this.getAuthTree();
    this.role_id = this.$route.query.id;
    if (this.role_id !== undefined && this.role_id.length > 0) {
      this.getRoleModel();
    }
  },
  methods: {
    itemIndeterminate(item) {
      if (!item.api_list) {
        item.api_list = [];
      }
      // 查找对应一级的接口存在
      return (
        item.allRule.some(v => this.choose_api_id_list.indexOf(v) > -1) &&
        !item.allRule.every(v => this.choose_api_id_list.indexOf(v) > -1)
      );
    },

    handleCheckAllChange(val, item) {
      // 筛选出当前点击的接口列表，进行全选
      const filterArr = this.choose_api_id_list.filter(
        v => item.allRule.indexOf(v) === -1
      );
      this.choose_api_id_list = val
        ? filterArr.concat(item.allRule)
        : filterArr;
    },
    handleCheckReadChange(val, item) {
      let array = [];
      //   先筛选出当前列表下所有的id值
      item.api_list.forEach(i => {
        if (i.name.indexOf("查询") > -1) {
          array.push(i.id);
        }
      });

      item.array = array;
      //   筛选选中的id
      const filterArr = this.choose_api_id_list.filter(
        v => item.allRule.indexOf(v) === -1
      );

      this.choose_api_id_list = val ? filterArr.concat(item.array) : filterArr;
      // 先判断当前数组的勾选状态，选中状态，再看是否选中的数据，有就选中，没有就不选中
      item.checkAll = val ? (array && array.length > 0 ? true : false) : false;
    },
    handleCheckedCitiesChange(value, i) {
      // 根据列表下的接口选择长度进行反选
      let checkedCount = value.length;
      this.auth_tree_list[i].checkAll =
        checkedCount === this.auth_tree_list[i].api_list.length;

      this.auth_tree_list[i].isIndeterminate =
        checkedCount > 0 &&
        checkedCount < this.auth_tree_list[i].api_list.length;
    },
    getAuthTree() {
      let _me = this;
      _me.loading = true;
      let params = {};
      _me.$common
        .httpPost("/api/admin/root/auth/category/find/tree", params)
        .then(res => {
          _me.loading = false;
          if (res.code === "1000000") {
            _me.auth_tree_list = res.data;

            _me.auth_tree_list = res.data.map(v => ({
              ...v,
              checkAll: false,
              itemIndeterminate: true,
              allRule:
                v.api_list && v.api_list.length > 0
                  ? v.api_list.map(i => i.id)
                  : []
            }));
          } else {
            _me.$message({
              message: res.message || _me.$t("errorMsg"),
              type: "error"
            });
          }
        })
        .catch(err => {
          _me.loading = false;
          _me.$message({
            message: err || _me.$t("errorMsg"),
            type: "error"
          });
        });
    },
    getRoleModel() {
      let _me = this;
      _me.loading = true;
      let params = {
        id: _me.role_id
      };
      _me.$common
        .httpPost("/api/admin/root/auth/role/find/id", params)
        .then(res => {
          _me.loading = false;
          if (res.code === "1000000") {
            _me.role_model = res.data;
            let api_list = _me.role_model.role_api_list;
            if (api_list !== undefined && api_list.length > 0) {
              for (let i = 0; i < api_list.length; i++) {
                let api_model = api_list[i];
                _me.choose_api_id_list.push(api_model.auth_id);
              }
            }
          } else {
            _me.$message({
              message: res.message || _me.$t("errorMsg"),
              type: "error"
            });
          }
        })
        .catch(err => {
          _me.loading = false;
          _me.$message({
            message: err || _me.$t("errorMsg"),
            type: "error"
          });
        });
    },
    saveModel() {
      let _me = this;
      _me.$refs["modelForm"].validate(valid => {
        if (valid) {
          if (_me.role_id !== undefined && _me.role_id.length > 0) {
            _me.updateModel();
          } else {
            _me.newModel();
          }
        } else {
          _me.$message({
            message: "请检查表单!",
            type: "error"
          });
        }
      });
    },
    updateModel() {
      let _me = this;
      let params = {
        id: _me.role_model.id,
        name: _me.role_model.name,
        number: _me.role_model.number,
        status: _me.role_model.status,
        role_api_list: _me.choose_api_id_list
      };
      _me.loading = true;
      _me.$common
        .httpPost("/api/admin/root/auth/role/update", params)
        .then(res => {
          _me.loading = false;
          if (res.code === "1000000") {
            _me.$message.success(_me.$t("successfullyModified"));
            _me.goBack();
          } else {
            _me.$message({
              message: res.message || _me.$t("errorMsg"),
              type: "error"
            });
          }
        })
        .catch(err => {
          _me.loading = false;
          _me.$message({
            message: err || _me.$t("errorMsg"),
            type: "error"
          });
        });
    },
    newModel() {
      let _me = this;
      let params = {
        name: _me.role_model.name,
        number: _me.role_model.number,
        status: _me.role_model.status,
        role_api_list: _me.choose_api_id_list
      };
      _me.loading = true;
      _me.$common
        .httpPost("/api/admin/root/auth/role/add", params)
        .then(res => {
          _me.loading = false;
          if (res.code === "1000000") {
            _me.$message.success(_me.$t("successfullyAdded"));
            _me.goBack();
          } else {
            _me.$message({
              message: res.message || _me.$t("errorMsg"),
              type: "error"
            });
          }
        })
        .catch(err => {
          _me.loading = false;
          _me.$message({
            message: err || _me.$t("errorMsg"),
            type: "error"
          });
        });
    },
    goBack() {
      // 返回上一级路由
      this.$router.go(-1);
      this.$common.removeGlobalStorage("authRoleList");
    },
    copyInfo(str) {
      let compare_list = [];
      this.auth_tree_list.forEach(item => {
        item.api_list.map(ele => {
          if (this.choose_api_id_list.indexOf(ele.id) != -1) {
            compare_list.push(ele.name);
          }
        });
        str.arr = compare_list;
      });
      // 触发赋值事件，将当前的数据传值
      this.$refs.copyPaste.CopyInfo(str);
    },
    // 粘贴信息
    pasteInfo(model) {
      // 接受粘贴事件的传值数据
      this.role_model = model;
      this.role_model.id = this.role_id;

      this.choose_api_id_list = [];
      this.auth_tree_list.forEach(item => {
        item.api_list.forEach(v => {
          if (model.arr.indexOf(v.name) != -1) {
            this.choose_api_id_list.push(v.id);
          }
        });
      });
    }
  }
};
</script>

<style scoped></style>
